var T = (r, n, e) => {
  if (!n.has(r))
    throw TypeError("Cannot " + e);
};
var k = (r, n, e) => (T(r, n, "read from private field"), e ? e.call(r) : n.get(r)), x = (r, n, e) => {
  if (n.has(r))
    throw TypeError("Cannot add the same private member more than once");
  n instanceof WeakSet ? n.add(r) : n.set(r, e);
}, L = (r, n, e, t) => (T(r, n, "write to private field"), t ? t.call(r, e) : n.set(r, e), e);
import { i as E } from "./reactive-element-BDpydG15.js";
import "../beacon-html.d/index.js";
import { s as R } from "./lit-element-DC8UPTKS.js";
import { property as f } from "../beacon-property.d/index.js";
import { state as M } from "../beacon-state.d/index.js";
import { unsafeStatic as _ } from "../beacon-static-html.d/index.js";
var S = /* @__PURE__ */ ((r) => (r.NO_SYNC = "no-sync", r))(S || {}), y = /* @__PURE__ */ ((r) => (r.VISIBLE = "visible", r.IDLE = "idle", r.INTERACTION = "interaction", r.MEDIA = "media", r.DEFINED = "defined", r))(y || {}), m = /* @__PURE__ */ ((r) => (r.BLUR = "beacon-event-blur", r.CHANGE = "beacon-event-change", r.CLICK = "beacon-event-click", r.FOCUS = "beacon-event-focus", r.HIDE = "beacon-event-hide", r.INPUT = "beacon-event-input", r.KEYDOWN = "beacon-event-keydown", r.MOUSEDOWN = "beacon-event-mousedown", r.MOUSEENTER = "beacon-event-mouseenter", r.MOUSELEAVE = "beacon-event-mouseleave", r.RENDER = "beacon-event-render", r.SORT = "beacon-event-sort", r.DEFERRED_CHILD = "beacon-event-deferred-child", r.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", r.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", r.LANGUAGE_SELECT = "beacon-event-language-select", r.PLAY = "beacon-event-play", r.CLOSE = "beacon-event-close", r.OPEN = "beacon-event-open", r.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", r.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", r.ELEMENT_READY = "beacon-event-element-ready", r.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", r.DRILLDOWN = "beacon-event-drilldown", r.DRILLUP = "beacon-event-drillup", r.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", r.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", r.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", r.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", r.HAS_CURRENT_LINK = "beacon-event-has-current-link", r.REGISTER = "beacon-event-register", r.SKIP_LINK_CLICK = "beacon-event-skip-link-click", r.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", r.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", r.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", r.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", r))(m || {}), $ = /* @__PURE__ */ ((r) => (r.CLOSE = "close", r.KEYDOWN = "keydown", r.SCROLL = "scroll", r.CLICK = "click", r.FOCUSOUT = "focusout", r))($ || {});
const U = E`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(a:not([focus-override])){--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, j = E`:host(:not([focus-override])) *:not(a:not([focus-override])):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:host(:not([focus-override])) a:not([focus-override]):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override])) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, V = E`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, K = E`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, F = E`.has-cell-padding{padding-block:var(--beacon-cell-space-padding);padding-inline:var(--beacon-cell-space-padding)}.has-component-padding{padding-block:var(--beacon-component-space-padding);padding-inline:var(--beacon-component-space-padding)}@media (width >= 1600px){:host{--beacon-space-default: calc(10 * var(--beacon-unit-base)) !important;--beacon-grid-layout-space-margin: 10rem !important;--beacon-grid-gutter-size-inline: 2rem !important}}:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));font-family:var(--beacon-system-font-family, var(--beacon-font-family-default));-webkit-font-smoothing:antialiased}[lang=zh]{font-family:var(--beacon-system-font-family, var(--beacon-font-family-cjk))}a,::slotted(a){color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}a:not(:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var N = /* @__PURE__ */ ((r) => (r.CLICKABLE = "data-metrics-clickable", r.TYPE = "data-metrics-type", r.TEXT = "data-metrics-link-text", r.LOCATION = "data-metrics-location", r))(N || {});
const p = class p {
};
p.setPropertyOnEvent = (n, e, t, o) => {
  try {
    Object.defineProperty(n, t, {
      value: o || e[`${t}`],
      writable: !1
    });
  } catch {
  }
}, p.getAnalyticsEvents = () => {
  const n = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(n.join("|")).test(e));
}, p.setHostEventHandlerForAnalytics = (n, e) => {
  var i;
  const t = p.getAnalyticsEvents(), o = "beaconVersion";
  for (const s of t) {
    const a = s.slice(2);
    (i = n.shadowRoot) == null || i.addEventListener(
      a,
      (l) => {
        var v;
        const c = new l.constructor(a, l);
        p.setPropertyOnEvent(c, null, o, e);
        for (const g in l)
          p.setPropertyOnEvent(c, l, g);
        (v = n.shadowRoot) != null && v.contains(l.target) && n.dispatchEvent(c);
      },
      !0
    );
  }
};
let I = p;
function te(r, n) {
  !r || !n || r instanceof SVGElement && (r.setAttribute(N.CLICKABLE, "true"), r.setAttribute(N.TYPE, "BTN"), r.setAttribute(N.TEXT, n));
}
function D(r, n, e, t) {
  const o = new CustomEvent(n, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return r.dispatchEvent(o), o;
}
const A = (r) => !!r.deferrable, H = (r) => {
  var n, e;
  return (!!((n = r.deferList) != null && n.includes(y.VISIBLE)) || !!((e = r.getAttribute("defer-until")) != null && e.includes(y.VISIBLE))) && r.isDeferUntilParent;
}, P = (r) => !!navigator.vendor && navigator.vendor.indexOf(r) > -1;
function G(r) {
  return `${r}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (n, e, t) => `${e.toUpperCase() + t}`).replace(new RegExp(/\w/), (n) => n.toUpperCase());
}
const W = "3.4.0", Y = {
  rootMargin: "1500px",
  threshold: 0.1
}, b = {
  version: W,
  hidden: "hidden",
  safari: "Apple",
  divTagName: "div",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: Y
}, O = (r) => {
  for (const n of r)
    if (n !== void 0)
      return n;
};
var z = Object.defineProperty, h = (r, n, e, t) => {
  for (var o = void 0, i = r.length - 1, s; i >= 0; i--)
    (s = r[i]) && (o = s(n, e, o) || o);
  return o && z(n, e, o), o;
}, w;
const u = class u extends R {
  constructor() {
    super(...arguments);
    x(this, w, void 0);
    L(this, w, !1), this.isDeferUntilParent = !1, this.deferrable = !0, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = b.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      var i;
      const o = (i = e.target.name) != null ? i : "";
      this.slotDeprecationWarn(o);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: b.defaultDeferOptions.rootMargin,
      threshold: b.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const t = new IntersectionObserver((o) => {
          const [i] = o;
          i.isIntersecting && (t.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        t.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((t) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => t(), { once: !0 }) : t();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((t) => {
          requestIdleCallback(() => {
            t();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((t) => {
      var o;
      e instanceof CustomEvent && ((o = e.detail) != null && o.type) ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => t())) : t();
    }), this.renderLightDOMStyles = (e = `${this.beaconTagName}-light-DOM-styles`) => {
      const t = [], o = new Set(this.constructor.lightDOMStyles.flat(1 / 0));
      for (const i of o)
        t.push(i);
      t.reverse().forEach((i, s) => {
        var c;
        const a = document.createElement("style");
        a.setAttribute("slot", "lightDOM");
        let l = !1;
        if (a.textContent = i.toString(), e) {
          const v = Math.abs(s - t.length), g = `${e}-${v}`, C = this.getClosestHost();
          a.id = g, (C && ((c = C == null ? void 0 : C.shadowRoot) != null && c.querySelector(`#${g}`)) || !C && document.querySelector(`#${g}`)) && (l = !0);
        }
        l || this.prepend(a);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var t;
      (t = this.componentModeStyles) == null || t.forEach((o, i) => {
        const s = document.createElement("style");
        s.textContent = o.toString();
        const a = `${e}-${i}`;
        s.id = a, !document.querySelector(`#${a}`) && document.head.append(s);
      });
    }, this.getScopedTag = (e) => {
      if (!e)
        return null;
      const t = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return _(t);
    };
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((t, o) => {
      this.elementProperties.has(t) && e.push(o);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, t, o) {
    const { alternateAttributesMap: i, hasDeprecatedProperties: s, elementProperties: a } = this.constructor;
    if (s && i.size > 0) {
      const l = i.get(e), c = a.get(l), v = this.getPropertyOptions(e).alternateSlot;
      if (l)
        if (l !== S.NO_SYNC && (o === null ? this.removeAttribute((c == null ? void 0 : c.attribute) || l) : this.setAttribute((c == null ? void 0 : c.attribute) || l, o || "")), v) {
          const g = this.createPropertyDeprecationForSlotMessage(e, v);
          console.warn(g);
        } else
          console.warn(this.createPropertyDeprecationMessage(e, l, c == null ? void 0 : c.attribute));
    }
    super.attributeChangedCallback(e, t, o);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param property property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, t, o) {
    let i = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return t !== S.NO_SYNC && (i += ` Start using [${o || t}] instead to avoid future disruptions.`), i;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, t) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${t}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, t) {
    if (t) {
      const { alternateAttributes: o, attribute: i } = t, s = Object.prototype.hasOwnProperty.call(t, "sync");
      if (b.deprecatedPropertyKeys.forEach((a) => {
        Object.prototype.hasOwnProperty.call(t, a) && (this.hasDeprecatedProperties = !0);
      }), o && o.forEach((a) => {
        this.alternateAttributesMap.set(a, e);
      }), s && !t.sync) {
        const a = i != null ? i : e;
        this.alternateAttributesMap.set(a, S.NO_SYNC);
      }
    }
    super.createProperty(e, t);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var o;
    const { elementProperties: t } = this.constructor;
    return (o = t.get(e)) != null ? o : [...t.values()].find((i) => i.attribute === e);
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, t;
    return (t = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((o) => o).filter((o) => !!o)) != null ? t : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const t = this.alternateSlots.get(e);
    if (t !== void 0) {
      let o;
      const i = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(t).some((s) => s.match("alternate")) ? t.alternateAttribute ? o = `will be replaced by the element property '${t.alternateAttribute}'` : o = `will be replaced by the '${t.alternateSlots}' slot` : o = "will be removed", console.warn(`Beacon Deprecation Warning: ${i} ${o} in foundation@${t.version}`);
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e)
      return;
    const t = { ...this.resolvedDeferOptions };
    this.resolvedDeferOptions = {
      root: O([e == null ? void 0 : e.root, t == null ? void 0 : t.root, document]),
      rootMargin: O([
        e == null ? void 0 : e.rootMargin,
        t == null ? void 0 : t.rootMargin,
        b.defaultDeferOptions.rootMargin
      ]),
      threshold: O([
        e == null ? void 0 : e.threshold,
        t == null ? void 0 : t.threshold,
        b.defaultDeferOptions.threshold
      ])
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    P(b.safari) || (this.style.visibility = b.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    P(b.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', t = this.closest(e);
    if (t && A(t))
      return t;
    const o = this.getClosestHost();
    if (o) {
      const i = o.closest(e);
      if (i && A(i))
        return i;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((t) => {
      e.includes(y.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), t();
      })) : e.includes(y.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), t();
      })) : t();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((t) => {
      if (e === null)
        t();
      else if (H(e))
        this.selectDeferUntilHandler(e.deferList).then(() => t());
      else {
        const o = (i) => {
          this.deferredChildEventHandler(i).then(() => {
            e.removeEventListener(m.DEFERRED_CHILD, o), t();
          });
        };
        e.addEventListener(m.DEFERRED_CHILD, o);
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable || this.motionState === "enabled")
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const t = this.getClosestDeferredParent();
        t ? this.handleParentalDeferUntil(t).then(() => e()) : e();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(y.VISIBLE)) {
      const e = new IntersectionObserver((t) => {
        for (const o of t)
          o.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const t = `${e ? `${e}-` : ""}${this.tagName}`;
      if (!customElements.get(t)) {
        const o = class extends this {
        };
        Object.defineProperty(o, "name", { value: G(t) }), customElements.define(t, o), customElements.whenDefined(t).then(() => {
          const i = new CustomEvent(m.REGISTER, { detail: t });
          document.dispatchEvent(i);
        }).catch((i) => {
          console.error(`Error defining Beacon Component ${t} in CustomElementsRegistry: `, i);
        });
      }
    }
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick(e) {
    D(this, m.CLICK, !!this.onBeaconClick && this.onBeaconClick(e));
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown(e, t) {
    D(this, m.KEYDOWN, !!this.onBeaconKeydown && this.onBeaconKeydown(t));
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild(e) {
    D(this, m.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown(e);
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var t;
    try {
      if (!((t = this.constructor.mixins) == null ? void 0 : t.includes(e)))
        throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (o) {
      return console.error(o), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, t) {
    try {
      if (!(e in this))
        throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === t;
    } catch (o) {
      return console.error(o), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender() {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender() {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy() {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), t = e == null ? void 0 : e.getAttribute("motion-state");
    t && (t === "enabled" || t === "disabled") && (this.motionState = t);
  }
  connectedCallback() {
    this.setMotionState(), this.handleDefer().then(() => {
      super.connectedCallback(), k(this, w) || (I.setHostEventHandlerForAnalytics(this, this.version), L(this, w, !0)), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), D(this, m.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
};
w = new WeakMap(), u.styles = [K, F, j], u.tagName = "", u.shadowRootOptions = { ...R.shadowRootOptions, delegatesFocus: !0 }, u.alternateAttributesMap = /* @__PURE__ */ new Map(), u.hasDeprecatedProperties = !1, u.mixins = [], u.lightDOMStyles = [V, U];
let d = u;
h([
  f({ attribute: "focus-override", type: Boolean, reflect: !0 })
], d.prototype, "focusOverride");
h([
  f({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], d.prototype, "resetSpacing");
h([
  f({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], d.prototype, "beaconTagName");
h([
  f({ attribute: "beacon-version", reflect: !0 })
], d.prototype, "version");
h([
  f({ attribute: "defer-until" })
], d.prototype, "deferUntil");
h([
  f({ attribute: "defer-options" })
], d.prototype, "deferOptions");
h([
  f({ type: Function })
], d.prototype, "onBeaconClick");
h([
  f({ type: Function })
], d.prototype, "onBeaconKeydown");
h([
  f({ attribute: "motion-state", reflect: !0 })
], d.prototype, "motionState");
h([
  M()
], d.prototype, "prefersReducedMotion");
export {
  N as A,
  d as B,
  $ as E,
  m as a,
  te as b,
  D as e
};
